
import React, { useState, useEffect } from 'react';

const WelcomeCurtain: React.FC = () => {
  const [isAnimating, setIsAnimating] = useState(false);
  const [isFinished, setIsFinished] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';

    // Snappier timings
    const startTimer = setTimeout(() => {
      setIsAnimating(true);
    }, 400);

    const endTimer = setTimeout(() => {
      setIsFinished(true);
      document.body.style.overflow = '';
    }, 1200);

    return () => {
      clearTimeout(startTimer);
      clearTimeout(endTimer);
      document.body.style.overflow = '';
    };
  }, []);

  if (isFinished) {
    return null;
  }

  return (
    <div 
        className="fixed inset-0 z-[9999] pointer-events-none flex items-center justify-center"
        aria-hidden="true"
    >
        {/* Logo with Morph/Zoom Effect */}
        <div className={`relative z-10 transition-all duration-700 ease-in-out ${isAnimating ? 'opacity-0 scale-150 blur-lg' : 'opacity-100 scale-100'}`}>
            <img 
              src="https://supoassets.s3.ap-south-1.amazonaws.com/public/sites/omniviewlabs/assets/icons/OVL+-+NewLogo.webp" 
              alt="Omniviewlabs Logo" 
              className="h-32 md:h-40 object-contain animate-breathing" 
            />
        </div>

        {/* Left Curtain */}
        <div className={`absolute top-0 left-0 h-full w-1/2 bg-[#090A0F] transition-transform duration-[1200ms] ease-[cubic-bezier(0.77,0,0.175,1)] origin-left ${isAnimating ? 'scale-x-0' : 'scale-x-100'}`}></div>
        
        {/* Right Curtain */}
        <div className={`absolute top-0 right-0 h-full w-1/2 bg-[#090A0F] transition-transform duration-[1200ms] ease-[cubic-bezier(0.77,0,0.175,1)] origin-right ${isAnimating ? 'scale-x-0' : 'scale-x-100'}`}></div>
    </div>
  );
};

export default WelcomeCurtain;
